import { useState } from 'react';
import { Box, Button, Popover, PaletteOutlinedIcon, Typography } from 'src/components';
import { DEFAULT_LINE_COLORS } from 'src/data';

export default function ColorPicker({ selectedColor, setSelectedColor }) {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);
  const open = Boolean(anchorEl);

  const handleColorPick = (color) => {
    setSelectedColor(color);
    handleClose();
  };

  return (
    <>
        <Button 
            variant="text"
            disableRipple
            onClick={handleClick} 
            sx={{ borderRadius: 2, flexDirection: 'row', p: 1, gap: 1 }}>
            <PaletteOutlinedIcon />
            <Typography variant="body2" fontWeight={600}>Color</Typography>
        </Button>

        <Popover
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            transformOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            PaperProps={{
            sx: {
                borderRadius: 100,
                padding: 1,
                display: 'flex',
                gap: 1,
                overflowX: 'auto',
                background: '#fff',
            },
            }}
        >
            {DEFAULT_LINE_COLORS.map((color) => (
            <Box
                key={color}
                onClick={() => handleColorPick(color)}
                sx={{
                    width: 28,
                    height: 28,
                    borderRadius: '50%',
                    backgroundColor: color,
                    border: selectedColor === color ? '2px solid black' : '2px solid transparent',
                    cursor: 'pointer',
                    transition: 'transform 0.2s',
                    '&:hover': {
                        transform: 'scale(1.1)',
                    },
                }}
            />
            ))}
        </Popover>
    </>
  );
}
